import { IdentityReferenceItem } from '@reg/shared/model';

/**
 * Model to a body assessment ineligible reason
 */
export class IdentityIneligibleReason extends IdentityReferenceItem {
    public static get INSTANCE_OF_NAME(): string {
        return 'BodyAssessmentIneligibleReason';
    }

    public clone(): IdentityIneligibleReason {
        return <IdentityIneligibleReason> super.clone();
    }

    public deserialize(json: Object): IdentityIneligibleReason {
        return <IdentityIneligibleReason> super.deserialize(json);
    }
}
